class CountdownBarTimer extends HTMLElement {
  constructor() {
    super();

    this.ANNOUNCEMENT_BAR_CLASS = 'announcement-bar--hidden';

    this.countdown = this.querySelector(".js-countdown");
    this.countdownBar = this.countdown.closest(".announcement-bar");
    this.date = this.getAttribute("js-countdown-date");
    this.countDownDate = Date.parse(this.date);

    this.initialiseCountdown();
  }

  getTimeRemaining() {
    const now = new Date().getTime();
    const total = this.countDownDate - now;
    const days = Math.floor(total / (1000 * 60 * 60 * 24));
    const hours = Math.floor((total % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((total % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((total % (1000 * 60)) / 1000);

    return {
      total,
      days,
      hours,
      minutes,
      seconds
    };
  }

  initialiseCountdown() {
    this.updateCountdown();
    this.interval = setInterval(this.updateCountdown.bind(this), 1000);
  }

  updateCountdown() {
    const time = this.getTimeRemaining();
    const daysSpan = this.countdown.querySelector(".countdown__days");
    const hoursSpan = this.countdown.querySelector(".countdown__hours");
    const minutesSpan = this.countdown.querySelector(".countdown__minutes");
    const secondsSpan = this.countdown.querySelector(".countdown__seconds");

    daysSpan.innerHTML = time.days > 0 ? time.days + " Days" : "";
    hoursSpan.innerHTML = time.hours > 0 ? time.hours + " Hrs" : "";
    minutesSpan.innerHTML = time.minutes > 0 ? this.formatTime(time.minutes) + " Mins" : "";

    if (time.seconds === 0) {
      secondsSpan.innerHTML = '00 Secs';
    } else {
      secondsSpan.innerHTML = this.formatTime(time.seconds) + " Secs";
    }

    if (this.getTimeRemaining().total > 0) this.countdownBar.classList.remove(this.ANNOUNCEMENT_BAR_CLASS);
    if (this.getTimeRemaining().total <= 0) {
      clearInterval(this.interval);

      this.countdownBar.classList.add(this.ANNOUNCEMENT_BAR_CLASS);
    }
  }

  formatTime(time) {
    return ('0' + time).slice(-2);
  }
}

customElements.define("countdown-bar-timer", CountdownBarTimer);